import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import { withCreateMeme } from "src/modules/meme/operations";
import { compose } from "src/helpers";

import CreateView from "./component";

const Create = (props) => {
    const { createMeme } = props;
    const router = useRouter();

    const onFinish = async (values: any) => {
        await createMeme(values);
        router.push("/meme");
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return <CreateView onFinish={onFinish} onFinishFailed={onFinishFailed} />;
};

export default compose(withCreateMeme)(Create);
